module.exports = __webpack_public_path__ + "site/img/email1.10747b0e.svg";